module.exports = {
        srcSet: __webpack_public_path__ + "ec9d354bb3e5dba1-600.webp"+" 600w"+","+__webpack_public_path__ + "17fe3d48d3182d10-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "ec9d354bb3e5dba1-600.webp",width: 600,height: 120},{path: __webpack_public_path__ + "17fe3d48d3182d10-1000.webp",width: 1000,height: 200}],
        src: __webpack_public_path__ + "17fe3d48d3182d10-1000.webp",
        toString: function(){return __webpack_public_path__ + "17fe3d48d3182d10-1000.webp"},
        
        width: 1000,
        height: 200
      }